export default "__VITE_ASSET__C$0LT8y0__"